<div class="OutsideContainer Flexbox Flexbox--column" #Container>
  <div class="MaterialContainer Grid Gap--smaller" [class.Animating]="shouldAnimate" #materialContainer>
    <mat-card *ngFor="let material of materialsToShow()" #MaterialCard [class.Selected]="this.selectedMaterial?.id === material.id" [class.Unavailable]="!reachableMaterials().includes(material.id)">
      <mat-card-content>
        <button mat-flat-button (click)="selectMaterial(material)">
          <div class="Flexbox Flexbox--column ButtonContent Gap--smaller">
            <div class="ImageContainer">
              <img [src]="getFullMaterialURL(material)" [alt]="material.displayName">
            </div>
            <div class="Flexbox ButtonName">
              <span>{{ material.displayName }}</span>
              <!-- <app-selection-indicator [isVisible]="this.selectedMaterial?.name === material.name" [shouldAnimate]="shouldAnimateSelection" [isUnavailable]="!availableMaterials?.includes(material.shortName)"></app-selection-indicator> -->
            </div>
          </div>
        </button>
      </mat-card-content>
    </mat-card>
  </div>

</div>
